import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['choice'];

  connect() {
    let checked = [];
    this.choiceTargets.forEach((choice) => {
      if (choice.checked) {
        checked.push(choice.dataset.cartItemId);
      }
    });

    // this.selectedCartItemIdsTarget.value = checked.join(',');
    // document.getElementById('selected_cart_items_ids').value = checked.join(',');
  }

  select(event) {
    let checked = [];
    this.choiceTargets.forEach((choice) => {
      if (choice.checked) {
        checked.push(choice.dataset.cartItemId);
      }
    });

    document.getElementById('selected_cart_items_ids').value = checked.join(',');
  }
}
